module.exports = __webpack_public_path__ + "static/img/riley_sm.cf37927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_icons/riley_sm.png
// module id = K7dm
// module chunks = 1